import { atom } from 'recoil';

export const isOpcFetchingAtom = atom<boolean>({
    key: 'isOpcFetchingAtom',
    default: false
});
